/* eslint-disable @typescript-eslint/no-unused-vars */
export const criterionSettingAudienceStyles = ({ palette = {} }) => ({
  '& .criterion-setting-Audience': {

    '& .col-sm-10': {
      width: '100%',
      '& .form-group': {
        margin: 0,
      },
    },

    '& a.audience__caption--folded': {
      display: 'inline-block',

      '& > span': {
        verticalAlign: 'unset',
      },
    },

    '& .create-audience-fallback-popover': {
      backgroundColor: palette.white,
      position: 'absolute',
      left: '160px !important',
      top: '-40px !important',
      zIndex: 5,
      '& .popover-view': {
        border: '1px solid #edebe9',
        boxShadow: '0 6.4px 14.4px 0 rgba(0,0,0,.132), 0 1.2px 3.6px 0 rgba(0,0,0,.108)',
        borderRadius: '2px',
        padding: '20px',
        width: '250px',
        '& .fallback-popover-title': {
          fontSize: '20px',
          lineHeight: '28px',
          fontWeight: 600,
        },
        '& .fallback-popover': {
          '& .message': {
            fontSize: '12px',
            lineHeight: '22px',
            paddingTop: '10px',
            paddingBottom: '10px',
          },
          '& .link-container': {
            fontsize: '16px',
            '& .iconba.iconba-OpenInNewWindow': {
              color: palette.themeDarkAlt,
              margin: '0 4px',
              top: '2px',
            },
          },
        },
      },
    },
  },
});

const linkedInTargetSelectionSyles = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }, {
  companySearchTableWidth = 450,
  companySearchTableCompanyNameWidth = 258,
  companyIconHeightWidth = 32,
  targetGridWidth = 514,
} = {}) => ({
  '& .target-intent-header': {
    marginBottom: 8,
  },

  '& .search-box__input-group': {
    position: 'relative',

    '& .search-box__input': {
      background: '#FFFFFF',
      border: `1px solid ${palette.neutralSecondary}`,
      boxSizing: 'border-box',
      borderRadius: 2,
      padding: '6px 8px 7px 32px',
      width: companySearchTableWidth,
    },

    '& .search-box__icon': {
      fontFamily: iconFontFamily,
      fontSize: 16,
      position: 'absolute',
      left: 0,
      color: '#0078D4',
      padding: 8,
      lineHeight: '16px',
    },

    '& .search-box__icon:before': {
      content: '"\\E721"',
    },
  },

  '& .company-search-container': {
    position: 'relative',

    '& .company-search-table': {
      width: companySearchTableWidth,
      height: '182px',
      overflow: 'auto',
      background: '#FFFFFF',
      boxShadow: '0px 0.6px 1.8px rgba(0, 0, 0, 0.108), 0px 3.2px 7.2px rgba(0, 0, 0, 0.132)',
      borderRadius: '0px 0px 2px 2px',
    },

    '& .empty-result-message': {
      position: 'absolute',
      top: 0,
    },
  },

  '& .company-item-template': {
    padding: '2px 8px 0 8px',
    '& .pull-right': {
      margin: 0,
      padding: 0,
      verticalAlign: 'top',

      '& .company-search-include-link': {
        textAlign: 'right',
      },

      '& .company-search-separator': {
        margin: '0 5px',
        verticalAlign: 'baseline',
      },
    },

    '& .pull-left': {
      marginTop: 5,
      marginRight: 7,

      '& img': {
        width: companyIconHeightWidth,
        height: companyIconHeightWidth,
        display: 'block',
        overflow: 'hidden',
      },
    },

    '& .company-name': {
      width: companySearchTableCompanyNameWidth,
      lineHeight: '20px',

      '& .company-item-name, .company-item-industry': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        paddingRight: 5,
      },
    },
  },

  '& .company-item-template:last-child': {
    paddingBottom: 13,
  },

  '& .linked-in-target-grid-container, .linked-in-excluded-grid-container': {
    marginTop: 8,
    position: 'relative',
    width: targetGridWidth,

    '& .target-grid-remove-all-container': {
      position: 'absolute',
      right: 10,
      top: 11,
    },

    '& .target-grid': {
      '& .table-container': {
        width: '100%',
        '& tr > th, tr > td': {
          height: '42px',
        },

        '& .table': {
          '& .header': {
            padding: '11px 8px 12px 7px',

            '& tr > th': {
              fontWeight: 'normal',
              height: '42px',
            },

            '& tr > th:first-child': {
              width: 140,
            },

            '& tr > th:nth-child(2)': {
              width: 325,
            },

            '& tr > th:nth-child(3)': {
              width: 149,
            },
          },

          '& tbody': {
            '& .linked-in-target-grid__area-row': {
              '& .text-left:nth-child(2)': {
                paddingLeft: 7,
                paddingRight: 8,
              },

              '& .text-left': {
                padding: 0,

                '& .statusEnabled_icon, .statusExcluded_icon': {
                  lineHeight: '19px',
                  padding: '12px 9px 11px 17px',
                },

                '& .company-item-template': {
                  padding: 0,

                  '& .pull-left': {
                    margin: 0,
                    padding: '5px 7px 5px 1px',
                  },

                  '& .company-name': {
                    width: '100%',
                    paddingRight: 8,

                    '& .company-item-name, .company-item-industry': {
                      width: 300,
                    },
                  },
                },

                '& .linked-in-target-grid__remove-col': {
                  fontFamily: iconFontFamily,
                  fontSize: 12,
                  color: '#605E5C',
                  textAlign: 'center',
                  padding: '15px 8px',
                },

                '& .linked-in-target-grid__remove-col:before': {
                  content: '"\\E711"',
                },
                '& .clickable': {
                  cursor: 'pointer',
                },
              },
            },
          },
        },
      },
    },
  },

  '& .linked-in-target-search-container': {
    width: companySearchTableWidth,

    '& .treeview': {
      border: `1px solid ${palette.neutralSecondary}`,
      width: companySearchTableWidth,
      height: '265px',
    },

    '& .search-result-tree': {
      padding: '8px 7px 8px 3px',
      height: '215px',
      overflowY: 'auto',

      '& .node-container': {
        '& .tree-node-container': {
          paddingBottom: 8,

          '& .grouped-node-title-container': {
            '& .glyphicon': {
              fontFamily: iconFontFamily,
              marginRight: 5,
            },
            '& .glyphicon-triangle-right:before': {
              content: '"\\F08F"',
            },
            '& .glyphicon-triangle-bottom:before': {
              content: '"\\F08E"',
            },

            '& span:last-child': {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },
          },

          '& .state-value-container': {
            float: 'right',
          },

          '& .children-container': {
            marginLeft: 18,

            '& .node-container': {
              '& .tree-node-container': {
                paddingBottom: 0,
                paddingTop: 2,

                '& span:first-child': {
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  display: 'inline-block',
                  width: companySearchTableWidth - 210,
                },

                '& .action-link, .action-separator': {
                  float: 'right',
                },

                '& .action-separator': {
                  margin: [0, 5],
                },
              },
            },
          },
        },
      },
    },
  },
});

const linkedInSharedStyles = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }, {
  companySearchTableWidth = 450,
  companySearchTableCompanyNameWidth = 258,
  companyIconHeightWidth = 32,
} = {}) => ({
  '& .col-sm-10, .col-sm-12': {
    width: '100%',

    '& .empty-result-message': {
      padding: 8,
    },

    '& .bid-adjustment-grids-container': {
      width: '816px',
    },

    '& .target-selection-container': {
      ...linkedInTargetSelectionSyles(
        { palette, iconFontFamily },
        {
          companySearchTableWidth,
          companySearchTableCompanyNameWidth,
          companyIconHeightWidth,
          targetGridWidth: 816,
        }
      ),
    },
  },
});

const searchBoxStyles = ({ companySearchTableWidth = 450 }) => ({
  '& .search-box__input-group': {
    '& .search-box__input': {
      border: '0 !important',
      borderBottom: '1px solid #F3F2F1 !important',
      width: `${companySearchTableWidth - 2}px !important`,
      height: '48px',
      paddingLeft: '48px !important',
    },

    '& .search-box__icon': {
      padding: '16px !important',
    },
  },
});

export const criterionSettingCompanyStyles = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }, {
  companySearchTableWidth = 450,
  companySearchTableCompanyNameWidth = 258,
  companyIconHeightWidth = 32,
  targetGridWidth = 514,
} = {}) => ({
  '& .criterion-setting-CompanyName': {
    ...linkedInTargetSelectionSyles(
      { palette, iconFontFamily },
      {
        companySearchTableWidth,
        companySearchTableCompanyNameWidth,
        companyIconHeightWidth,
        targetGridWidth,
      }
    ),
  },
});

export const criterionSettingIndustryStyles = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }, {
  companySearchTableWidth = 450,
  companySearchTableCompanyNameWidth = 258,
  companyIconHeightWidth = 32,
  targetGridWidth = 514,
} = {}) => ({
  '& .criterion-setting-Industry': {
    '& div': {
      ...linkedInTargetSelectionSyles(
        { palette, iconFontFamily },
        {
          companySearchTableWidth,
          companySearchTableCompanyNameWidth,
          companyIconHeightWidth,
          targetGridWidth,
        }
      ),
    },
    ...searchBoxStyles({ companySearchTableWidth }),
  },
});

const jobFunctionSearchStyles = ({ companySearchTableWidth = 450 }) => ({
  '& .searchbox-container': {
    border: '1px solid #605E5C',
    width: companySearchTableWidth,
    height: '265px',
  },

  '& .search-result-view-container': {
    height: '215px',
    overflow: 'auto',

    '& .job-function-item-template': {
      padding: '8px 8px 9px 8px',
      lineHeight: '19px',

      '& .job-function-item-name': {
        width: companySearchTableWidth - 180,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },

      '& .job-function-search-separator': {
        margin: [0, 5],
        verticalAlign: 'baseline',
      },
    },
  },
});

export const criterionSettingJobFunctionStyles = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }, {
  companySearchTableWidth = 450,
  companySearchTableCompanyNameWidth = 258,
  companyIconHeightWidth = 32,
  targetGridWidth = 514,
} = {}) => ({
  '& .criterion-setting-JobFunction': {
    '& div': {
      ...linkedInTargetSelectionSyles(
        { palette, iconFontFamily },
        {
          companySearchTableWidth,
          companySearchTableCompanyNameWidth,
          companyIconHeightWidth,
          targetGridWidth,
        }
      ),
    },
    ...searchBoxStyles({ companySearchTableWidth }),
    ...jobFunctionSearchStyles({ companySearchTableWidth }),
  },
});

export const selectorContainerStyles = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }, {
  companySearchTableWidth = 400,
  companySearchTableCompanyNameWidth = 258,
  companyIconHeightWidth = 32,
}) => ({
  '& button.btn.btn-primary#location': {
    marginTop: 0,
  },
  '& .item-container:not(#location-setting-container)': {
    marginLeft: '1.3em',
    border: '0em',
    '& label.checkbox-inline': {
      display: 'flex',
    },
    '& .criterion-setting-Industry, .criterion-setting-JobFunction': {
      ...searchBoxStyles({ companySearchTableWidth }),
    },
    '& .criterion-setting-JobFunction': {
      ...jobFunctionSearchStyles({ companySearchTableWidth }),
    },
    '& .search-box__input-group': {
      position: 'relative',
      '& .search-box__input': {
        background: '#FFFFFF',
        border: '1px solid #B3B0AD',
        boxSizing: 'border-box',
        borderRadius: 2,
        padding: '6px 8px 7px 32px',
        width: companySearchTableWidth,
      },
      '& .search-box__icon': {
        fontFamily: iconFontFamily,
        fontSize: 16,
        position: 'absolute',
        left: 0,
        color: '#0078D4',
        padding: 8,
        lineHeight: '16px',
      },
      '& .search-box__icon:before': {
        content: '"\\E721"',
      },
    },
    '& .criterion-setting-CompanyName, .criterion-setting-Industry, .criterion-setting-JobFunction': {
      ...linkedInSharedStyles(
        { palette, iconFontFamily },
        {
          companySearchTableWidth,
          companySearchTableCompanyNameWidth,
          companyIconHeightWidth,
        }
      ),
      marginLeft: '-15px',
    },
    '& .audience-setting-container': {
      '& .searchbox': {
        marginLeft: '15px',
      },
      '& .create-audience-link-section div': {
        marginLeft: '13px',
      },
      '& label.checkbox-label#IMAIneligibleToggleLable': {
        marginLeft: '18px',
      },
    },
  },
  '& .item-container#location-setting-container': {
    marginLeft: '0.3em',
    border: '0em',
  },
});

export const selectorContainerBtnStyles = ({ iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  margin: '0em',
  background: 'transparent',
  display: 'inline-block',
  paddingLeft: '0.3em',
  marginTop: 40,
  color: '#605e5c',
  '& .summary-details': {
    color: '#605e5c',
    fontWeight: 'normal',
    display: 'block',
    border: 0,
    margin: 0,
    textAlign: 'left',
    visibility: 'visible',
  },
  '& .target-header': {
    margin: '0 em',
    display: 'flex',
    border: '0em',
    // new
    '&:before': {
      color: '#0078D4',
      content: '"\\E76C"',
      fontFamily: iconFontFamily,
      marginRight: 8,
      position: 'relative',
      // display: 'flex',
      top: 2,
    },
    '& p.target-selection-title': {
      color: '#0078D4',
      margin: 0,
      padding: 0,
      border: '0em',
      fontWeight: 'bold',
    },
    '& p.target-selection-title:hover': {
      color: '#004578',
      textDecoration: 'underline',
    },
  },
  '&[aria-expanded="true"] .target-header:before': {
    content: '"\\E70D"',
  },
});

export const audienceTargetsSettingsStyles = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }, {
  companySearchTableWidth = 450,
  companySearchTableCompanyNameWidth = 258,
  companyIconHeightWidth = 32,
} = {}) => ({
  '& .crud-audience-adgroup': {
    color: '#323130',
    padding: [24, 32],
    overflow: 'hidden',
    zoom: 1,
  },
  '& .crud-audience-adgroup, & .audience-adgroup-settings-wizard-container, & .campaign-targets, & .adgroup-targets-section, & .adgroup-targets, & .criterion-creation-container, & .new-creation-flow-target-selector-container': {
    '& table.table--no-border>tbody>tr:hover, table.table-hover>tbody>tr:hover': {
      background: palette.neutralLight,
      '& td': {
        border: `1px solid ${palette.white}`,
      },
    },

    '& .optimized-selector-container, & .optimized-container, & .audience-target-settings-container': {
      ...selectorContainerStyles(
        { palette, iconFontFamily },
        {
          companySearchTableWidth,
          companySearchTableCompanyNameWidth,
          companyIconHeightWidth,
        }
      ),
      '& button.btn.btn-primary.expand-btn': {
        ...selectorContainerBtnStyles({ iconFontFamily }),
      },
    },

    '& .adgroup-name-input-container': {
      '& .name-input-control-container': {
        padding: 0,
        width: 461,

        '& .form-control': {
          padding: [6, 8, 7, 8],
          border: `1px solid ${palette.neutralSecondary}`,
          boxSizing: 'border-box',
          borderRadius: 2,
          width: 461,
          marginTop: 2,
          backgroundColor: '#FFFFFF',
          // i added this
          '-webkit-user-select': 'all',
          '-moz-user-select': 'all',
          '-ms-user-select': 'all',
          userSelect: 'all',
        },

        '& .remaining-chars-hint': {
          marginBottom: 0,
          marginTop: 3,
        },
      },
    },

    '& .crud-audience-target-selector': {
      width: 900,

      '& .crud-audience-target-selector__description': {
        fontSize: 14,
        lineHeight: 1.5,
        color: '#323130',
        paddingTop: 26,
        marginBottom: 10.5,
        border: 'none',
      },

      '& .selection-item-container': {
        width: 259,
        height: '92px',
        padding: 0,
        margin: [0, 37, 37, 0],

        '& .selection-item-button': {
          color: '#323130',
          width: 259,
          height: '92px',
          backgroundColor: '#F3F2F1',
          paddingLeft: 13,
          paddingRight: 14,
          position: 'relative',

          '&:hover': {
            zIndex: 0,
            border: '1px solid #323130',
          },

          '&:focus': {
            border: '1px solid #605E5C',
          },

          '&:active': {
            borderColor: palette.themePrimary,
            zIndex: 0,

            '& .glyphicon-plus:before': {
              color: palette.themePrimary,
              content: '"\\EC61"',
            },
          },

          '& .col-sm-1': {
            position: 'absolute',
            right: 0,
            top: 0,
            paddingLeft: 0,

            '& .glyphicon-ok, .glyphicon-plus': {
              fontSize: 18,
              fontFamily: iconFontFamily,
              position: 'unset',
              margin: 0,
            },
            '& .glyphicon-ok:before': {
              color: palette.themePrimary,
              content: '"\\EC61"',
            },
            '& .glyphicon-plus:before': {
              color: palette.neutralPrimary,
              position: 'relative',
              zIndex: '-1',
              content: '"\\ECCA"',
            },

          },

          '& .col-sm-11': {
            width: 232,
            padding: 0,
            position: 'absolute',
            top: '50%',
            transform: 'translate(0px, -50%)',

            '& .selection-item-description': {
              fontWeight: 'lighter',
              whiteSpace: 'normal',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              '-webkit-line-clamp': 3,
              '-webkit-box-orient': 'vertical',
            },

          },
        },

        '& .selection-item-button.active': {
          border: [1, 'solid', '#0078D4'],

          '&:hover': {
            borderColor: palette.themeDarker,
            '& .glyphicon-ok:before': {
              color: palette.themeDarker,
            },
          },
        },
      },
      '& .audience-selector-container': {
        '& h5.control-label': {
          display: 'none',
        },
        '& button.btn.btn-primary.btn-dropdown': {
          ...selectorContainerBtnStyles({ iconFontFamily }),
        },
        ...selectorContainerStyles(
          { palette, iconFontFamily },
          {
            companySearchTableWidth,
            companySearchTableCompanyNameWidth,
            companyIconHeightWidth,
          }
        ),
      }, // audience target selector container
    }, // crud audience target selector container

    '& .audience-target-settings-container, .criterion-setting-container-in-creation': {
      '& .parent-level-bid-adjustment-grid': {
        width: 1000,
        '& .pull-left': {
          marginRight: 7,
        },
      },
      '& .show-cashback-percent': {
        '& .table-container': {
          '& .company-item-template': {
            display: 'flex',
            '& .pull-left': {
              marginRight: 10,
            },
            '& .company-name': {
              width: 200,
            },
          },
          '& .cashback-percent-cell': {
            '& .input-group-addon': {
              border: 'none',
              background: 'none',
              padding: 0,
              verticalAlign: 'middle',
              lineHeight: '30px',
            },
          },
        },
        '& .cashback-percent-col': {
          '& .inline-input.form-control': {
            width: 66,
          },
        },
        '& .linked-in-target-grid-view .column-header.column-header-leaf.column-name-BidAdjustment': {
          width: '254px !important',
        },
        '& .current-level-bid-adjustment-grid': {
          width: 1000,
        },
        '&.criterion-setting-CompanyName, &.criterion-setting-Industry, &.criterion-setting-JobFunction': {
          '& .linked-in-target-grid-container': {
            width: '1000px !important',
          },
        },
        '& .cashback-percent-cell': {
          '& input': {
            width: 60,
          },
        },
        '& .linked-in-target-grid-view': {
          '& .target-grid': {
            '& .column-header.column-name-isIncludedOrExcluded': {
              width: '100px !important',
            },
            '& .column-header': {
              '&.column-name-targetName': {
                width: 'auto !important',
              },
              '&.column-name-name': {
                width: '223px !important',
              },
            },
            '& .bid-adjustment-target-column input': {
              width: 60,
            },
            '& .company-item-template': {
              '& .company-name': {
                '& .company-item-name, & .company-item-industry': {
                  width: '200px !important',
                },
              },
            },
          },
        },
      },
      paddingBottom: 15,

      '& .pagination-control': {
        '& .pager': {
          display: 'inline-block',
          marginLeft: 20,
        },
      },

      '& .location-setting-controller': {
        marginBottom: 0,

        '& .control-label': {
          marginTop: 10,
        },

        '& .searchbox-input': {
          padding: [3, 33, 3, 12],
        },

        '& .radio': {
          paddingTop: 0,
        },
      },

      '& .criterion-setting-Age, .criterion-setting-Gender': {

        '& .target-selection-container': {
          '& .form-group': {
            margin: 0,

            '& .row': {
              '& .col-sm-3': {
                paddingLeft: 0,
              },
              '& .checkbox-inline': {
                '& input, div': {
                  float: 'left',
                },
              },

            },
            '& .errors-container': {
              padding: 0,
            },
          },
        },
      },

      ...criterionSettingAudienceStyles({ palette }),

      '& .criterion-setting-CompanyName .col-sm-12 .target-selection-container .searchbox-container .search-box__input-group .search-box__input': {
        width: companySearchTableWidth,
      },

      '& .criterion-setting-CompanyName .col-sm-10 .target-selection-container .searchbox-container .search-box__input-group .search-box__input': {
        width: companySearchTableWidth,
      },

      '& .target-selection-container': {
        '& .column-name-BidAdjustment': {
          width: '280px !important',
        },
        '& .column-name-removeAll': {
          width: '149px !important',
        },
        '& tbody': {
          '& .linked-in-target-grid__area-row': {
            '& .bid-adjustment-target-column select.form-control,input.form-control': {
              display: 'inline-block !important',
              'margin-left': '5px',
            },
          },
        },
      },

      '& .criterion-setting-CompanyName, .criterion-setting-Industry, .criterion-setting-JobFunction': {
        ...linkedInSharedStyles(
          { palette, iconFontFamily },
          {
            companySearchTableWidth,
            companySearchTableCompanyNameWidth,
            companyIconHeightWidth,
          }
        ),
      },
      '& .criterion-setting-Industry, .criterion-setting-JobFunction': {
        ...searchBoxStyles({ companySearchTableWidth }),
      },
      '& .criterion-setting-JobFunction': {
        ...jobFunctionSearchStyles({ companySearchTableWidth }),
      },
    },

    '& .errors-container': {
      float: 'left',
      clear: 'both',
      padding: '0 15px 15px 15px',
    },

    '& .audience-advanced-target-settings': {
      paddingTop: 10,
    },

    '& .glyphicon-pencil': {
      marginRight: 11,
    },

    '& .no-target-exist-edit-label': {
      marginRight: 5,
      '& u': {
        'text-decoration': 'none',
      },
    },

    '& .edit-target-show-button': {
      verticalAlign: 'middle',
    },

    '& .edit-target-show-button-container': {
      paddingBottom: 8,
    },

    '& .done-editing-target-button': {
      background: palette.themePrimary,
      color: palette.white,

      '&:focus:after': {
        border: `1px solid ${palette.white}`,
        bottom: 1,
        left: 1,
        right: 1,
        top: 1,
      },
    },

    '& .level-toggle-container': {
      padding: '5px 0',
      marginBottom: 10,

      '& .level-toggle': {
        marginRight: 8,
        float: 'left',
      },
    },

    '& .alert-info.form-group.adgroup-override-info': {
      lineHeight: 1.5,
      margin: '8px 0',
      padding: 8,

      '& .alert-image': {
        marginTop: 3,
        float: 'left',
      },
      '& .alert-info-inline': {
        '& a': {
          textDecoration: 'underline',
        },
      },
    },

    '& .location-target-done': {
      margin: '0 12px 0 15px',
    },

  },
  '& .adgroup-targets': {
    '& .linked-in-target-grid-container': {
      '& .column-name-BidAdjustment': {
        width: '280px !important',
      },
      '& .column-name-removeAll': {
        width: '149px !important',
      },
      '& tbody': {
        '& .linked-in-target-grid__area-row': {
          '& .bid-adjustment-target-column select.form-control,input.form-control': {
            display: 'inline-block !important',
            'margin-left': '5px',
          },
        },
      },
    },
  },
});
